"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTask = createTask;
exports.deleteTask = deleteTask;
exports.getTaskList = getTaskList;
exports.getUserTaskDailyList = getUserTaskDailyList;
exports.getUserTaskLogList = getUserTaskLogList;
exports.updateTask = updateTask;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 查询任务列表
function getTaskList(query) {
  return (0, _request.default)({
    url: '/admin/platform/task/list',
    method: 'post',
    data: query
  });
}

// 新增任务
function createTask(data) {
  return (0, _request.default)({
    url: '/admin/platform/task/create',
    method: 'post',
    data: data
  });
}

// 修改任务
function updateTask(data) {
  return (0, _request.default)({
    url: '/admin/platform/task/update',
    method: 'post',
    data: data
  });
}

// 删除任务
function deleteTask(taskId) {
  return (0, _request.default)({
    url: '/admin/platform/task/delete/' + taskId,
    method: 'post'
  });
}

// 获取用户每日任务统计列表
function getUserTaskDailyList(params) {
  return (0, _request.default)({
    url: '/admin/platform/task/userDaily/list',
    method: 'get',
    params: params
  });
}

// 获取用户任务完成记录列表
function getUserTaskLogList(params) {
  return (0, _request.default)({
    url: '/admin/platform/task/userLog/list',
    method: 'get',
    params: params
  });
}